import type { VideoStatus } from 'models';
import { useCallback } from 'react';
import { Icon, type TagProperties } from 'ui';

export const useGetVideoStatusTagProperties = () =>
  useCallback(({ status }: { status: VideoStatus }): TagProperties => {
    switch (status) {
      case 'archived':
        return { bordered: true, children: 'Video (Archived)', icon: <Icon icon="archive-line" /> };
      case 'draft':
        return { bordered: true, children: 'Video (Draft)', icon: <Icon icon="document-3-line" /> };
      case 'published':
        return { children: 'Video', color: 'purple', icon: <Icon icon="video-line" /> };
    }
  }, []);
